import { ID } from '@models/base'
import { PatientModel } from '@models/patient'

import { ClinicModel } from './clinic'
import { DoctorModel } from './doctor'

export enum AppointmentStatusEnum {
  PENDING = 'PENDING',
  CANCELED = 'CANCELED',
  SCHEDULED = 'SCHEDULED',
  CHECKED_IN = 'CHECKED_IN',
}

export type AppointmentModel = {
  id: ID
  clinic_id?: ID
  appointment_clinic?: ClinicModel
  appointment_clinic_id?: ID
  patient_id?: ID
  doctor_id?: ID
  code?: string
  subject?: string
  type?: string
  remark?: string
  started_at?: string
  ended_at?: string
  status?: AppointmentStatusEnum
  updated_at?: string
  doctor?: DoctorModel
  clinic?: ClinicModel
  patient?: PatientModel
}
